import { BaseStyle } from './styled.js';
import { jsx } from 'react/jsx-runtime';

function StyleReset() {
  return /*#__PURE__*/jsx(BaseStyle, {});
}

export { StyleReset };
